import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const SEASON = {
  ESTIVA: { label: "Estiva", cls: "border-amber-200 bg-amber-50 text-amber-800" },
  INVERNALE: { label: "Invernale", cls: "border-sky-200 bg-sky-50 text-sky-800" },
  QUATTRO_STAGIONI: { label: "4 stagioni", cls: "border-emerald-200 bg-emerald-50 text-emerald-800" },
};
export const AXLE = { ANTERIORI: "Anteriori", POSTERIORI: "Posteriori", TUTTE: "Tutte e 4" };
export const STATUS = {
  ORDINATO: { label: "Ordinato", cls: "border-slate-300 bg-slate-100 text-slate-700" },
  CONFERMATO: { label: "Confermato", cls: "border-blue-200 bg-blue-50 text-blue-800" },
  PARZIALE: { label: "Arrivato in parte", cls: "border-amber-200 bg-amber-50 text-amber-800" },
  ARRIVATO: { label: "Arrivato · a magazzino", cls: "border-emerald-200 bg-emerald-50 text-emerald-800" },
  ANNULLATO: { label: "Annullato", cls: "border-rose-200 bg-rose-50 text-rose-700" },
};
export const fd = (d) => (d ? new Date(d).toLocaleDateString("it-IT") : "—");
export const today = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Rome" });

export const SeasonBadge = ({ season }) => season ? (
  <span className={`whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-semibold ${SEASON[season].cls}`}>{SEASON[season].label}</span>
) : null;

export const TyreCell = ({ t }) => t ? (
  <div className="min-w-[10rem]"><p className="text-xs font-medium text-slate-800">{t.label.split(" · ")[0]}</p><SeasonBadge season={t.season} /></div>
) : <span className="text-xs text-slate-400">Non registrate</span>;

export const openTyreFile = async (f) => {
  try {
    const { data } = await api.get(`/tyres/files/${f.id}`, { responseType: "blob" });
    window.open(URL.createObjectURL(data), "_blank");
  } catch (e) { toast.error(errMsg(e)); }
};

export const Tabs = ({ value, onChange, items, prefix }) => (
  <div className="inline-flex flex-wrap rounded-lg border border-slate-200 bg-white p-1">
    {items.map(([k, l]) => <button key={k} onClick={() => onChange(k)} data-testid={`${prefix}-${k}`}
      className={`rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${value === k ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"}`}>{l}</button>)}
  </div>
);
